import * as React from 'react';
import { Field, getIn } from 'formik';

import EmployerAutocomplete from '@buyside/components/presentation/EmployerAutocomplete/EmployerAutocomplete';
import Selectable from '@buyside/components/presentation/Selectable/selectable';
import InputField from '@buyside/components/presentation/Form/Field/InputField/inputField';

const { jobTypes, fundTypeNames, aumRangeNames } = require('buyside/util/constantsFromRails.json');

import { InvestorTypes, AllFormikProps } from '@interfaces/userApplication/userApplication';
import { SelectableTypes } from '@interfaces/selectable/selectable';

const { RADIO } = SelectableTypes;
const { buyside, allocator } = InvestorTypes;

import styles from '../pageStyles.scss';

export type EmployedProps = Pick<
  AllFormikProps,
  'setFieldValue' | 'errors' | 'touched' | 'setFieldError' | 'values' | 'initialValues'
>;

const Employed: React.FunctionComponent<EmployedProps> = ({
  setFieldValue,
  touched,
  errors,
  setFieldError,
  values,
  initialValues
}): React.ReactElement => {
  const { investorType } = values;
  const isTouched = getIn(touched, 'investorType');
  const error = getIn(errors, 'investorType');
  return (
    <>
      <h4>Tell us about your current employment.</h4>
      <div className={styles.inputField}>
        <EmployerAutocomplete
          analyticsTag="application-employed-current-employer"
          label="Current Employer"
          name="employerName"
          placeholder="Begin Typing..."
          setFieldValue={setFieldValue}
          setFieldError={setFieldError}
        />
      </div>
      <div className={styles.inputField} data-heap="application-employed-job-role">
        <Field component={InputField} label="Role" name="title" options={jobTypes} type="select" />
      </div>
      <div className={styles.inputFieldHalf} data-heap="application-employed-firm-type">
        <Field
          component={InputField}
          label="Firm Type"
          name="employerFundType"
          options={fundTypeNames}
          type="select"
          disabled={
            Boolean(initialValues?.employerFundType) &&
            initialValues?.employerName === values?.employerName &&
            fundTypeNames.includes(initialValues?.employerFundType)
          }
        />
      </div>
      <div className={styles.inputFieldHalf} data-heap="application-employed-aum-firm-range">
        <Field
          component={InputField}
          label="AUM Range of Firm"
          name="employerAumRange"
          options={aumRangeNames}
          type="select"
          disabled={
            Boolean(initialValues?.employerAumRange) &&
            initialValues?.employerName === values?.employerName &&
            aumRangeNames.includes(initialValues?.employerAumRange)
          }
        />
      </div>
      <h4>Do you allocate to third-party managers?</h4>
      <div className={styles.inputFieldHalf}>
        <Selectable
          analyticsTag="application-allocator-yes"
          id="investorEmployerIsAllocator"
          name="investorType"
          onChange={(): void => {
            setFieldValue('investorType', allocator);
          }}
          selectableType={SelectableTypes.RADIO}
          checked={investorType === allocator}
        >
          <div className={styles.selectableTextCentered}>
            <p>Yes</p>
          </div>
        </Selectable>
      </div>
      <div className={styles.inputFieldHalf}>
        <Selectable
          analyticsTag="application-allocator-no"
          id="investorEmployerNotAllocator"
          onChange={(): void => {
            setFieldValue('investorType', buyside);
          }}
          name="investorType"
          selectableType={RADIO}
          checked={investorType === buyside}
        >
          <div className={styles.selectableTextCentered}>
            <p>No</p>
          </div>
        </Selectable>
      </div>
      {isTouched && error && <div className={styles.fieldError}>{error}</div>}
    </>
  );
};

export default Employed;
